module.exports = __webpack_public_path__ + "public/img/douyin.1e642c6e.png";